import { useState } from 'react'
import { Input } from '@/Components/Form/Inputs'
import { isCurrency, CURRENCY_SYMBOLS } from '@/Constants/currencies'

interface BudgetInputProps {
  initialValue?: number | ''
  onChange: (value: number | '') => void
  hasError?: boolean
  currency?: string
}

const BudgetInput = ({ initialValue = '', onChange, hasError, currency }: BudgetInputProps) => {
  const [budget, setBudget] = useState<number | ''>(initialValue)
  const currencySymbol = isCurrency(currency) ? CURRENCY_SYMBOLS[currency] : '£'

  const handleChange = (value: number | '') => {
    setBudget(value)
    onChange(value)
  }

  return (
    <div className='flex flex-col gap-4'>
      <p className='!font-bold text-sm sm:text-base text-black leading-6'>
        What&apos;s the budget for your event? <span className='text-[#af231c]'>*</span>
      </p>
      <div className='flex flex-col gap-2 max-w-[394px]'>
        <label
          htmlFor='duplicate-budget'
          className='text-sm sm:text-base font-normal text-[#1F1F1F]'>
          Budget
        </label>
        <Input
          id='duplicate-budget'
          type='number'
          min='0'
          step='1'
          value={budget}
          onChange={({ target }) => handleChange(target.value ? parseInt(target.value, 10) : '')}
          placeholder={`${currencySymbol} 0`}
          className='placeholder:text-[#1f1f1f] placeholder:font-normal'
          style={{ borderColor: hasError ? '#af231c' : '#BFBFBF' }}
          compact
        />
        {hasError && <p className='!text-[#af231c] text-sm'>Please enter a budget.</p>}
      </div>
    </div>
  )
}

export default BudgetInput
